import {
  Autocomplete,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
  
  const GenderSelect = ({
    label = "Gender",
    value = "",
    onBlur = () => {},
    onChange = () => {},
    error,
  }) => {

    const { Common, Translation } = useSelector((state) => ({
      Common: state.Common.common,
      Translation: state.Translation.translation?.Common || {},
    }));

    const genderList = Common?.Gender || [];

    const selectedOption = React.useMemo(() => {
      return genderList.find((item) => item.ID === value) || null;
    }, [genderList, value]);

    return (
      <FormControl fullWidth>
        <FormLabel color="secondary" required label>
          {/* {label} */}
          {Translation?.Gender}
        </FormLabel>
        <Autocomplete
          options={genderList}
          autoHighlight
          getOptionLabel={(option) => option.Value}
          clearIcon={false}
          value={selectedOption}
          onBlur={onBlur}
          onChange={(value, newVal) => onChange(newVal)}
          noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
          renderOption={(props, option) => {
            const { key, ...optionProps } = props;
            return (
              <Typography key={key} {...optionProps}>
                {option?.Value}
              </Typography>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              error={Boolean(error)}
              name="GenderID"
              placeholder={Translation?.EnterYourGender}
              helperText={error}
              slotProps={{
                htmlInput: {
                  ...params.inputProps,
                  autoComplete: "new-password",
                },
              }}
            />
          )}
        />
      </FormControl>
    );
  };
  
  export default GenderSelect;
  